import { render, staticRenderFns } from "./adminbanslov.vue?vue&type=template&id=c01c1848&"
import script from "./adminbanslov.vue?vue&type=script&lang=js&"
export * from "./adminbanslov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports